import * as Yup from 'yup'
import { emptyFieldMessage } from './messagesContants'
import './offerRecipientYupValidation'

export const offerEndBuyersValidationSchema = {
  offerEndBuyers: Yup.array()
    .of(
      Yup.object().shape({
        firstName: Yup.string().test(
          'conditional-required',
          emptyFieldMessage,
          function (value) {
            const { firstName, lastName, email, title } = this.parent
            const hasAnyValue = firstName || lastName || email || title
            if (hasAnyValue && !value) {
              return false
            }
            return true
          }
        ),
        lastName: Yup.string().test(
          'conditional-required',
          emptyFieldMessage,
          function (value) {
            const { firstName, lastName, email, title } = this.parent
            const hasAnyValue = firstName || lastName || email || title
            if (hasAnyValue && !value) {
              return false
            }
            return true
          }
        ),
        title: Yup.string().nullable(),
        email: Yup.string()
          .test(
            'conditional-email-format',
            'Enter a valid email address.',
            function (value) {
              const { firstName, lastName, email, title } = this.parent
              const hasAnyValue = firstName || lastName || email || title
              if (hasAnyValue && value) {
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
              }
              return true
            }
          )
          .test(
            'conditional-required',
            'Enter a valid email address.',
            function (value) {
              const { firstName, lastName, email, title } = this.parent
              const hasAnyValue = firstName || lastName || email || title
              if (hasAnyValue && !value) {
                return false
              }
              return true
            }
          ),
      })
    )
    .uniqueProperty('email', 'Duplicate emails is not allowed.'),
}
